import { IInstitutionEgeForAdmission } from '@ucheba/store/institutions/item/types'

export interface IInstitutionExamsProps {
  data: IInstitutionEgeForAdmission[]
}

export interface IInstitutionExamsItemProps {
  institutionId: string | string[] | undefined
  programCount: number | null
  subjects: IInstitutionEgeForAdmission['subjects']
}

export enum EActivityInfoPart {
  egeVariants = 'egeVariants',
  benefits = 'benefits',
  news = 'news',
  opinions = 'opinions',
  questions = 'questions',
  teachers = 'teachers',
  olympiads = 'olympiads',
  employers = 'employers',
  events = 'events',
  indicators = 'indicators',
}
